// Private

import AppDialogManagerService from '../components/dialogs/AppDialogManager/app-dialog-manager-service';

// Public

const editAndSaveConfiguration = async (configurationIds, applyConfigurationsResponseOnDraft) => {
	await AppDialogManagerService.openRespondConfigurationDialog({ configurationIds, applyConfigurationsResponseOnDraft });
};

const WorkflowConfigurationResponseService = { editAndSaveConfiguration };

export default WorkflowConfigurationResponseService;
